<script>
export default {
    name: "IconMinus"
}
</script>

<template>
    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
         fill="none" viewBox="0 0 18 2">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M1 1h16"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
